import { Component, OnInit } from '@angular/core';

import { ConfirmationService, MessageService } from 'primeng/api';

import { Fornecedor } from '../models/fornecedor';
import { FornecedorService } from '../fornecedor.service';


@Component({
  selector: 'app-fornecedor-list',
  templateUrl: './fornecedor-list.component.html',
  styleUrls: ['./fornecedor-list.component.scss'],
  providers: [ConfirmationService, MessageService]
})

export class FornecedorListComponent implements OnInit {

  public fornecedores: Fornecedor[];
  public idFornecedor: number;
  public fornecedor: Fornecedor;
  
  public submitted: boolean;
  public displayMsg: boolean = false;
  public displayDialog: boolean;

  constructor(public fornecedorService: FornecedorService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService) { }

  ngOnInit(): void {

   
    this.getFornecedores();    
    
  }

  getFornecedores() {
    this.fornecedorService.getFornecedores().subscribe(
      (res) => {
        if (res) {
          this.fornecedores = res;  
          console.log(this.fornecedores);
        }
      },
      err => {
        console.log("FornecedorList - Fornecedores");
        console.log(err);
      }
    );
  } 

  getFornecedor(idfornecedor) {

    this.fornecedorService.getFornecedor(idfornecedor).subscribe(
      (res) => {
        if (res) {
          this.fornecedor = res;
        }
      },
      err => {
        console.log("fornecedorList - fornecedor");
        console.log(err);
      }
    );
  }
  

  addFornecedor() {
    this.fornecedor = {};
    this.submitted = false;
    this.displayDialog = true;
  } 
  
  updFornecedor(fornecedor: Fornecedor) {      
    this.fornecedor = {...fornecedor};
    this.displayDialog = true;
  }
  
  delFornecedor(fornecedor: Fornecedor) {
      this.confirmationService.confirm({
          message: 'Você tem certeza que deseja remover o fornecedor: ' + fornecedor.nome + '?',
          header: 'Confirmação',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
              this.fornecedorService
              .delFornecedor(fornecedor.idFornecedor)
              .subscribe(                     
                  () => this.getFornecedores(),
                  err => console.log(err)
              );
              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Fornecedor removido com sucesso!', life: 3000});
          }
      });
  }
  
  hideDialog() {
      this.displayDialog = false;
      this.submitted = false;        
  }
  
  saveFornecedor() {
      this.submitted = true;      
      if (this.fornecedor.nome.trim()) {
          if (this.fornecedor.idFornecedor) {
            
            this.fornecedorService
            .updFornecedor(this.fornecedor)
            .subscribe(                     
                () => this.getFornecedores(),
                err => console.log(err)
            );
              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Fornecedor atualizado com sucesso!', life: 3000});
          } else {
             this.fornecedorService
                 .addFornecedor(this.fornecedor)
                 .subscribe(                     
                     () => this.getFornecedores(),
                     err => 
                     {
                        this.messageService.add({severity: 'warning', summary: 'Erro', detail: 'Ocorreu um erro ao salvar as alterações!', life: 3000});
                       console.log(err)
                     }
                 );

              this.messageService.add({severity: 'success', summary: 'Sucesso', detail: 'Fornecedor atualizado com sucesso!', life: 3000});
          }
  
          this.fornecedores = [...this.fornecedores];
          this.displayDialog = false;
          this.fornecedor = {};
      }
  }
}
